import { useFormikContext } from 'formik';

import { FormControl } from '@@/form-components/FormControl';
import { Option, PortainerSelect } from '@@/form-components/PortainerSelect';
import { Button, LoadingButton } from '@@/buttons';

export interface FormValues {
  environmentGroups: Array<number>;
}

interface EnvironmentGroupsPickerProps {
  groupOptions: Array<Option<number>>;
  groupOptionsLoading: boolean;
}

export function EnvironmentGroupsPicker({
  groupOptions,
  groupOptionsLoading,
}: EnvironmentGroupsPickerProps) {
  const { values, setFieldValue, dirty, resetForm, submitForm, isSubmitting } =
    useFormikContext<FormValues>();

  return (
    <FormControl
      label="Environment groups"
      tooltip="Select one or more environment groups to attach to this alert rule"
    >
      <div className="flex items-center gap-2">
        <div className="flex-grow">
          <PortainerSelect<number>
            isMulti
            value={values.environmentGroups}
            onChange={(newGroups) =>
              setFieldValue('environmentGroups', newGroups)
            }
            options={groupOptions}
            isLoading={groupOptionsLoading}
            disabled={isSubmitting}
            data-cy="alert-rule-groups-select"
            noOptionsMessage={() => 'No environment groups available.'}
          />
        </div>
        {dirty && (
          <div className="flex shrink-0 gap-2">
            <LoadingButton
              type="button"
              color="primary"
              size="medium"
              onClick={submitForm}
              disabled={isSubmitting}
              isLoading={isSubmitting}
              loadingText="Applying changes"
              data-cy="apply-group-changes"
            >
              Apply changes
            </LoadingButton>
            <Button
              color="default"
              size="medium"
              onClick={() => resetForm()}
              disabled={isSubmitting}
              data-cy="cancel-group-changes"
            >
              Cancel
            </Button>
          </div>
        )}
      </div>
    </FormControl>
  );
}
